import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "addAddressLink", "imageInput", "imagePreview", "bookingDatePlus", "bookingDateMinus"
  ]

  connect() {
    this.rowNum = 999
    // this.checkAddressLimit()
  }

  // addAddress(event) {
  //   this.checkAddressLimit()
  // }

  // removeAddress(event) {
  //   this.checkAddressLimit()
  // }

  // checkAddressLimit() {
  //   const fieldsCount = this.addressesTarget.querySelectorAll('.nested-fields').length
  //   if (fieldsCount >= 3) {
  //     this.addAddressLinkTarget.classList.add("d-none")
  //   } else {
  //     this.addAddressLinkTarget.classList.remove("d-none")
  //   }
  // }

  previewImage(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imagePreviewTarget.src = e.target.result
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  addBookingTime(event) {
    event.preventDefault()
    this.rowNum++

    const weekDay = event.currentTarget.dataset.weekDay
    const bookingId = event.currentTarget.dataset.bookingId

    const container = document.querySelector(`.${weekDay}`)
    const html = `
      <div class="checkbox checkbox-success col-md-4 pt-2"></div>
      <div class="time-select artists-panel row p-2 col-md-8">
        <div class="row">
          <input class="form-control form-inline col-md-3 col-4 mr-3 mb-2 ml-3" type="text" name="specialist[booking_dates_attributes][${this.rowNum}][booking_times_attributes][${this.rowNum}][start_hour]" data-controller="cleave" data-cleave-options-value="{&quot;time&quot;:true,&quot;timePattern&quot;:[&quot;h&quot;,&quot;m&quot;]}" >
          <span style="padding-top: 2%;"> às </span>
          <input type="hidden" name="specialist[booking_dates_attributes][${this.rowNum}][id]" value="${bookingId}">
          <input class="form-control form-inline col-md-3 col-4 mr-3 mb-2 ml-4" type="text" name="specialist[booking_dates_attributes][${this.rowNum}][booking_times_attributes][${this.rowNum}][end_hour]" data-controller="cleave" data-cleave-options-value="{&quot;time&quot;:true,&quot;timePattern&quot;:[&quot;h&quot;,&quot;m&quot;]}" >
        </div>
      </div>
    `
    container.insertAdjacentHTML("afterend", html)
  }

  removeBookingTime(event) {
    event.preventDefault()
    const bookingId = event.currentTarget.dataset.bookingId
    const timeId = event.currentTarget.dataset.timeId
    const itemId = event.currentTarget.dataset.itemId

    const block = document.getElementById(`test-${bookingId}-${timeId}`)
    if (block) {
      block.style.display = "none"
      const destroyField = document.getElementById(`destroy-time-${itemId}`)
      if (destroyField) destroyField.checked = true
    }
  }
}
